module.exports = __webpack_public_path__ + "img/24.2.TN.06792ea8.png";